import React from 'react';
import PropTypes from 'prop-types';
import Creator from './Creator';
import AlertWarning from '@/dialogs_new/_common/AlertWarning';
import AlertSuccess from '@/dialogs_new/_common/AlertSuccess';
import AlertInfo from '@/dialogs_new/_common/AlertInfo';
import useMissingFields from '@/dialogs_new/event_manage/useMissingFields';
import { getDaysExpired, isExpired } from '@/utils/dateTimeUtils';

export default function CloseEventAlert(props) {
  const { event } = props;

  const diff = getDaysExpired(event.data.endDate);

  const { missingFields } = useMissingFields(event);

  const status = {
    Planning: (
      missingFields.data.length > 0 &&
      !(
        event.data.completed ||
        event.data.cancelled
      )
    ),
    Active: (
      missingFields.data.length === 0 &&
      !isExpired(event.data.endDate)
    ),
    Expired: isExpired(event.data.endDate),
    Completed: event.data.completed,
    Cancelled: event.data.cancelled
  };

  if (status.Completed) {
    return (
      <AlertSuccess
        title="Event has been marked complete"
        subtitle="Evaluations may still be ongoing."
      />
    );
  }

  if (status.Cancelled) {
    return (
      <AlertSuccess
        title="Event has been cancelled"
        subtitle="Nothing to do here."
      />
    );
  }

  if (status.Active) {
    return (
      <AlertInfo
        title="Event is active"
        subtitle="It is visible to partners and they are able to be invited to participate."
      />
    );
  }

  if (status.Planning) {
    return (
      <AlertInfo
        title="Event is in the planning stage"
        subtitle="There are required fields that are missing."
      />
    );
  }

  if (status.Expired) {
    return (
      <AlertWarning
        title={`Date window elapsed ${diff} days ago.`}
        subtitle="Contact the educator to extend the date window or encourage them to close the event."
      >
        <Creator event={event}/>
      </AlertWarning>
    );
  }

  return null;
}

CloseEventAlert.propTypes = {
  event: PropTypes.shape({
    data: PropTypes.shape({
      endDate: PropTypes.string,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool
    })
  }).isRequired
};
